module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_08@2x-96e08af5853e1fcb18e6cbcc0e48866a.jpg";